import { getEnvDependentEndpoint } from '@sitegen/common/utils/ubi-services';
import { delay } from '@sitegen/common/utils/timer';
import { OVERLAY_SDK_LOCATION, OVERLAY_INIT_ERROR_MESSAGE } from './constants';
import { IWindowWithOverlay } from './types';

export const getOverlaySDKEndpoint = (envName: string) => {
    return getEnvDependentEndpoint({ envName, source: OVERLAY_SDK_LOCATION });
};

export const getEmbeddedOverlay = (
    onError: Function,
    onSuccess: Function,
    // for Safari case the overlay initializing can be more than 10 seconds
    maxAttempts: number = 20
) => {
    async function reserve(value: number = 0) {
        const overlayWidget = (window as IWindowWithOverlay).overlayWidget || {};
        const overlayConnectSDK = (window as IWindowWithOverlay).overlayConnectSDK;

        if (value === maxAttempts) {
            // eslint-disable-next-line no-console
            console.error(OVERLAY_INIT_ERROR_MESSAGE);
            return onError();
        }

        if (overlayWidget.hasInitialized && overlayConnectSDK) {
            return onSuccess();
        }

        await delay(1000);

        reserve(++value);
    };

    return reserve();
};